import React, { useState, useEffect } from 'react';

const ScheduleTab = ({ show }) => {
  const [scheduleItems, setScheduleItems] = useState([]);

  useEffect(() => {
    if (show) {
      aggregateSchedule();
    }
  }, [show]);

  const aggregateSchedule = () => {
    const items = [];

    // Add flights (only booked ones)
    if (show.flights && show.flights.length > 0) {
      show.flights
        .filter(flight => flight.status === 'booked')
        .forEach(flight => {
          const airlineName = typeof flight.airline === 'string' ? flight.airline : flight.airline?.name || 'Unknown';
          const flightNumber = flight.flightNumber || flight.flight_number || '';
          const departureAirport = flight.departure?.airport || flight.origin || 'XXX';
          const arrivalAirport = flight.arrival?.airport || flight.destination || 'XXX';
          const departureTime = flight.departure?.time || flight.departure_time;
          
          items.push({
            type: 'flight',
            time: departureTime,
            title: `${departureAirport} → ${arrivalAirport}`,
            subtitle: `${airlineName} ${flightNumber}`,
            icon: '',
            data: flight
          });
        });
    }

    // Add hotels (only booked ones)
    if (show.hotels && show.hotels.length > 0) {
      show.hotels
        .filter(hotel => hotel.status === 'booked')
        .forEach(hotel => {
          // Format address - handle both old string format and new object format
          const formatAddress = (hotel) => {
            if (typeof hotel.address === 'string') return hotel.address;
            if (hotel.address && typeof hotel.address === 'object') {
              const parts = [];
              if (hotel.address.street) parts.push(hotel.address.street);
              if (hotel.address.city) parts.push(hotel.address.city);
              if (hotel.address.state) parts.push(hotel.address.state);
              if (hotel.address.country) parts.push(hotel.address.country);
              return parts.join(', ') || 'Address TBD';
            }
            return hotel.city || 'Address TBD';
          };

          // Check-in
          items.push({
            type: 'hotel-checkin',
            time: hotel.checkIn || hotel.check_in_time,
            title: `Check in ${hotel.hotelName || hotel.hotel_name}`,
            subtitle: formatAddress(hotel),
            icon: '',
            data: hotel
          });
          // Check-out
          if (hotel.checkOut || hotel.check_out_time) {
            items.push({
              type: 'hotel-checkout',
              time: hotel.checkOut || hotel.check_out_time,
              title: `Check out`,
              subtitle: hotel.hotelName || hotel.hotel_name,
              icon: '',
              data: hotel
            });
          }
        });
    }

    // Add ground transport
    if (show.ground_transport && show.ground_transport.length > 0) {
      show.ground_transport.forEach(transport => {
        items.push({
          type: 'transport',
          time: transport.pickup_time,
          title: transport.type || 'Ground Transport',
          subtitle: transport.notes || `${transport.vehicle_type}`,
            icon: '',
          data: transport
        });
      });
    }

    // Add show itself
    items.push({
      type: 'show',
      time: show.showInfo?.showtimes || '22:00',
      title: 'Soundcheck',
      subtitle: show.venue?.name || 'Unknown Venue',
            icon: '',
      data: show
    });

    // Sort by time
    items.sort((a, b) => {
      const timeA = a.time || '00:00';
      const timeB = b.time || '00:00';
      return timeA.localeCompare(timeB);
    });

    setScheduleItems(items);
  };

  const formatTime = (timeString) => {
    if (!timeString) return '';
    // Handle both full datetime and time-only strings
    try {
      const date = timeString.includes('T') ? new Date(timeString) : new Date(`2000-01-01T${timeString}`);
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    } catch {
      return timeString;
    }
  };

  return (
    <div className="px-4 space-y-3 pb-6">
      {scheduleItems.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-[rgba(255,255,255,0.5)] text-[12px] mb-2">
            No schedule items yet
          </p>
          <p className="text-[rgba(255,255,255,0.4)] text-[11px]">
            Add flights, hotels, and transportation to build your schedule
          </p>
        </div>
      ) : (
        scheduleItems.map((item, index) => (
          <div
            key={`${item.type}-${index}`}
            className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[rgba(255,255,255,0.3)] transition-all"
          >
            <div className="flex items-start gap-3">
              {item.icon && <div className="text-[24px]">{item.icon}</div>}
              <div className="flex-1">
                <p className="text-white text-[12px] font-medium mb-1">
                  {formatTime(item.time)} – {item.title}
                </p>
                <p className="text-[rgba(255,255,255,0.6)] text-[11px]">
                  {item.subtitle}
                </p>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ScheduleTab;

